import * as React from "react";
import { UrlObject } from "url";
import { NextRouter } from "next/router";
import { InternalLink } from "../common/Link";
import { Button } from "@mui/material";

interface Props {
    label: string;
    href: UrlObject;
    router: NextRouter;
}

export const TabLink = (p: Props) => {
    const active = p.href.pathname && p.router.pathname === p.href.pathname;

    return (
        <InternalLink href={p.href}>
            <Button color={active ? "secondary" : "primary"}>{p.label}</Button>
        </InternalLink>
    );
};
